import React, { forwardRef } from 'react'
import { LabelComponent } from 'transfix-ui/components/LabelComponent'
import { TextField as MuiTextField, OutlinedTextFieldProps } from 'transfix-ui/core'
import { makeStyles, createStyles } from 'transfix-ui/core/styles'

export interface IAutocompleteTextFieldProps extends Omit<OutlinedTextFieldProps, 'variant'> {
  /**
   * @default false
   */
  required?: boolean
}

type TClassKey = 'root'

const useAutocompleteTextFieldStyles = makeStyles(() =>
  createStyles<TClassKey, IAutocompleteTextFieldProps>({
    root: {
      '& input[type="text"]': {
        border: 'none',

        '&:focus, &:hover': {
          border: 'none !important',
        },
      },
      /**
       * Removes "notch" line behind label
       */
      '& [class*="MuiOutlinedInput-notchedOutline"]': {
        // Fixes small visual inconsistency
        top: ({ label }) => (label ? -5 : 0),

        '& span, & legend': {
          display: 'none',
        },
      },
    },
  })
)

const AutocompleteTextField = forwardRef<HTMLInputElement, IAutocompleteTextFieldProps>(
  ({ label, required, ...props }, ref) => {
    const classes = useAutocompleteTextFieldStyles(props)
    return (
      <MuiTextField
        className={classes.root}
        ref={ref}
        variant='outlined'
        label={label ? <LabelComponent required={required} label={label} /> : null}
        {...props}
      />
    )
  }
)

export default AutocompleteTextField
